import { CommonModule, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { FolderTreeNode } from '../ingest-folder-utils';

@Component({
  selector: 'app-folder-tree',
  standalone: true,
  imports: [CommonModule, NgTemplateOutlet],
  templateUrl: './folder-tree.component.html',
  styleUrls: ['./folder-tree.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FolderTreeComponent {
  readonly root = input.required<FolderTreeNode>();
  readonly selectedPath = input<string>('');

  readonly selectPath = output<string>();

  pick(path: string): void {
    this.selectPath.emit(path);
  }

  isSelected(path: string): boolean {
    return this.selectedPath() === path;
  }
}
